/**
 * Generated runtime TestId mirror for frontend/src/pages/admin/RehireReview.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const RehireReviewTestIds = {
  badgeDecidedByConnector: "badge-decided-by-connector",
  colDecidedBy: "col-decided-by",
  colDetectedAt: "col-detected-at",
  colMatchedIdentity: "col-matched-identity",
  colNewEntryDate: "col-new-entry-date",
  colSourceConnector: "col-source-connector",
  colStatus: "col-status",
  rehireReviewEmpty: "rehire-review-empty",
  rehireReviewList: "rehire-review-list",
  rehireReviewLoading: "rehire-review-loading",
  cellDecidedBy: (candidate_id: string) => `cell-decided-by-${candidate_id}`,
  cellDecidedByPrefix: () => "cell-decided-by-" as TestIdPrefix,
  rehireReviewRow: (candidate_id: string) => `rehire-review-row-${candidate_id}`,
  rehireReviewRowPrefix: () => "rehire-review-row-" as TestIdPrefix
} as const;
